import { createSlice } from '@reduxjs/toolkit';

const employeeReducer = createSlice({
  name: 'employeeReducer',
  initialState: {
    empToRenderOnMap: []
  },
  reducers: {
    setEmployeeToRenderOnMap: (state, action) => {
       return {
        ...state,
        empToRenderOnMap: [...action.payload]
       }     
    },
    resetEmployeeToRenderOnMap:()=>{ return {empToRenderOnMap:[]}},
  },
});


export const { setEmployeeToRenderOnMap, resetEmployeeToRenderOnMap } = employeeReducer.actions;
export default employeeReducer.reducer;